import { render, staticRenderFns } from "./ReclamoWizard.html?vue&type=template&id=3c9fd504&external"
import script from "./ReclamoWizard.vue?vue&type=script&lang=js"
export * from "./ReclamoWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports